import Vue from 'vue';
import Router from 'vue-router';
Vue.use(Router);

import Editor from '../pages/Editor.vue'
import MobileVR from '../pages/MobileVR.vue'
import MobileIndex from '../pages/MobileIndex.vue'

const routes = [
  {
    path: '/',
    redirect: '/mobile'
  },
  // {
  //   path: '/editor',
  //   component: Editor
  // },
  {
    path: '/mobile',
    component: MobileVR
  },
  {
    path: '/index',
    component: MobileIndex
  },
  {
    path: '*',
    redirect: '/'
  }
];

const router = new Router({
  mode: 'history',
  routes
});

router.beforeEach((to, from, next) => {
  next();
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js